import { useLatest } from 'ahooks'

import type { TrackEventParamsSchemaInput } from '@loc/server/interface/track/trackEventParams.common'


import { useEffect } from 'react';
export type TrackEventElement = HTMLElement & {
  $$observeTrackEvent?: () => void
}

export function getTrackEventSignature(
  trackEvent?: TrackEventParamsSchemaInput,
) {
  return JSON.stringify(trackEvent || null)
}

export function bindTrackEventToElement<T extends TrackEventElement>(
  ele: T,
  trackElementName: string,
  trackEvent: TrackEventParamsSchemaInput,
) {
  ele.setAttribute(trackElementName, '')
  ele.$$getTrackEvent = () => trackEvent
  ele.$$observeTrackEvent?.()
}

export function createUseDataTrackEventProps(trackElementName: string) {
  return <T extends HTMLElement>(
    ref: React.Ref<T>,
    trackEvent?: TrackEventParamsSchemaInput,
  ) => {
    const latestTrackEvent = useLatest(trackEvent)
    const trackEventSignature = getTrackEventSignature(trackEvent)

    useEffect(() => {
      if (!ref) {
        return
      }
      if (typeof ref === 'function') {
        return
      }
      if (!ref.current) {
        return
      }

      if (latestTrackEvent.current) {
        bindTrackEventToElement(
          ref.current as T & TrackEventElement,
          trackElementName,
          latestTrackEvent.current,
        )
      }
    }, [latestTrackEvent, ref, trackElementName, trackEventSignature])
  }
}
